import { render, staticRenderFns } from "./AHome.vue?vue&type=template&id=05af7fda&scoped=true"
import script from "./AHome.vue?vue&type=script&lang=js"
export * from "./AHome.vue?vue&type=script&lang=js"
import style0 from "./AHome.vue?vue&type=style&index=0&id=05af7fda&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05af7fda",
  null
  
)

export default component.exports